export default () => ({
  debug: null,
  enabled: false,
});
